import type { StyleConfigProps } from '../types';

export const HEADING_VARIANTS = [
  'XHugeBlack',
  'XLargeBlack',
  'HugeBlack',
  'LargeBlack',
  'MediumBlack',
  'SmallBlack',
  'Default18',
  'Default20',
  'Default24',
  'Default28',
  'Default32',
  'Default36',
  'Bold18',
  'Bold20',
  'Bold24',
  'Bold28',
  'Bold32',
  'Bold36',
] as const;

export const HEADING_CONFIG: StyleConfigProps<typeof HEADING_VARIANTS> = {
  XHugeBlack: {
    fontSize: '28px',
    lineHeight: '35px',
    letterSpacing: '-0.005em',
    fontWeight: 900,
  },
  XLargeBlack: {
    fontSize: '20px',
    lineHeight: '26px',
    letterSpacing: '-0.005em',
    fontWeight: 900,
  },
  HugeBlack: {
    fontSize: '24px',
    lineHeight: '30px',
    letterSpacing: '-0.005em',
    fontWeight: 900,
  },
  LargeBlack: {
    fontSize: '18px',
    lineHeight: '23px',
    fontWeight: 900,
  },
  MediumBlack: {
    fontSize: '16px',
    lineHeight: '21px',
    fontWeight: 900,
  },
  SmallBlack: {
    fontSize: '14px',
    lineHeight: '19px',
    fontWeight: 900,
  },
  Default18: {
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: 400,
  },
  Default20: {
    fontSize: '20px',
    lineHeight: '26px',
    fontWeight: 400,
    letterSpacing: '-0.1px',
  },
  Default24: {
    fontSize: '24px',
    lineHeight: '30px',
    fontWeight: 400,
    letterSpacing: '-0.12px',
  },
  Default28: {
    fontSize: '28px',
    lineHeight: '35px',
    fontWeight: 400,
    letterSpacing: '-0.14px',
  },
  Default32: {
    fontSize: '32px',
    lineHeight: '41.6px',
    fontWeight: 400,
    letterSpacing: '-0.32px',
  },
  Default36: {
    fontSize: '36px',
    lineHeight: '46.8px',
    fontWeight: 400,
    letterSpacing: '-0.36px',
  },
  Bold18: {
    fontSize: '18px',
    lineHeight: '24px',
    fontWeight: 900,
  },
  Bold20: {
    fontSize: '20px',
    lineHeight: '26px',
    letterSpacing: '-0.1px',
    fontWeight: 900,
  },
  Bold24: {
    fontSize: '24px',
    lineHeight: '30px',
    letterSpacing: '-0.12px',
    fontWeight: 900,
  },
  Bold28: {
    fontSize: '28px',
    lineHeight: '35px',
    letterSpacing: '-0.14px',
    fontWeight: 900,
  },
  Bold32: {
    fontSize: '32px',
    lineHeight: '41.6px',
    letterSpacing: '-0.32px',
    fontWeight: 900,
  },
  Bold36: {
    fontSize: '36px',
    lineHeight: '46.8px',
    letterSpacing: '-0.36px',
    fontWeight: 900,
  },
};
